import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import { ContainerAttributes } from "react-builder";
import styled from "styled-components";
import { RegistrationContext } from "./LandingPage";

@AttributeGroup({ title: 'RegistrationLoader', blockName: 'RegistrationLoader' })
export class RegistrationLoaderAttributes extends Attribute {

    @AttributeProperty({ type: 'Object', cssTarget: '.RegistrationLoader' })
    container: ContainerAttributes = new ContainerAttributes()
}

const RegistrationLoaderTheme = styled.div((props: { attributes: RegistrationLoaderAttributes }) => `

    ${props.attributes.toCSS()}

    :not(.is-loading):not(.is-selected){
        display: none !important;
    }

`);

export function RegistrationLoader(props: ComponentProps<RegistrationLoaderAttributes>) {
    return (
        <RegistrationContext.Consumer>
            {value =>
                <RegistrationLoaderTheme {...props} attributes={props.attributes} className={`RegistrationLoader ${props.className} ${value.isLoading ? 'is-loading' : ''} `}>
                    {props.children}
                </RegistrationLoaderTheme>
            }
        </RegistrationContext.Consumer>
    )
}


RegistrationLoader.prototype.Props = RegistrationLoaderAttributes;


export default RegistrationLoader;